import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBAnimation, MDBCard, MDBCardBody } from "mdbreact";
import TableLoading from "../../../../../components/tableLoading";
import { RESET } from "../../../../../services/redux/slices/market/machines";
import MachineFooter from "./footer";
import MachineHeader from "./header";
import MachineModal from "./modal";
import MachineTable from "./table";
import { buildSummary } from "./utils";

export default function MachineBoard({ mode = "registry" }) {
  const dispatch = useDispatch();
  const { filtered = [], isLoading, isSuccess, message } = useSelector(
    ({ machines }) => machines
  );

  useEffect(() => {
    if (isSuccess || message) {
      const timer = setTimeout(() => dispatch(RESET()), 2500);
      return () => clearTimeout(timer);
    }
  }, [dispatch, isSuccess, message]);

  const summary = buildSummary(filtered);

  return (
    <MDBAnimation type="fadeIn">
      <MDBCard narrow className="pb-3" style={{ minHeight: "600px" }}>
        <MachineHeader mode={mode} />
        <MDBCardBody>
          <div className="row mb-4">
            <SummaryCard title="Tieup Machines" value={summary.total} tone="info" />
            <SummaryCard title="Functional" value={summary.functional} tone="success" />
            <SummaryCard title="Expiring Warranty" value={summary.expiring} tone="warning" />
            <SummaryCard title="Overdue PM" value={summary.overdue} tone="danger" />
          </div>
          {isLoading ? <TableLoading /> : <MachineTable mode={mode} />}
        </MDBCardBody>
        <MachineFooter />
      </MDBCard>
      <MachineModal mode={mode} />
    </MDBAnimation>
  );
}

function SummaryCard({ title, value, tone }) {
  return (
    <div className="col-md-3 mb-3">
      <div className={`card border-${tone} h-100`}>
        <div className="card-body">
          <div className="text-muted small">{title}</div>
          <div className={`h3 mb-0 text-${tone}`}>{value}</div>
        </div>
      </div>
    </div>
  );
}
